import React from 'react';
import Select from '../../../../../components/shared/Select/Select';

interface ThemeSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  id?: string;
}

const themeOptions = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' },
];

const ThemeSelector: React.FC<ThemeSelectorProps> = ({ value, onChange, id = 'theme' }) => {
  return (
    <Select
      label="Theme"
      id={id}
      value={value}
      options={themeOptions}
      onChange={onChange}
      className="setting-select"
    />
  );
};

export default ThemeSelector;